import { useMutation } from '@tanstack/react-query';
import { Form, Input, Modal } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { useEffect } from 'react';
import { renameTopic } from 'src/apis/helpdesk/topic.api';
import { useChatStore } from 'src/stores/chatStore';
import { showNotification } from 'src/utils/notification';

export type RenameTopicOpenType = {
  isOpen: boolean;
  topicId?: string;
};

interface TopicRenameModalProps {
  open: RenameTopicOpenType;
  setOpen: (open: RenameTopicOpenType) => void;
}

const TopicRenameModal = ({ open, setOpen }: TopicRenameModalProps) => {
  const [form] = useForm();

  // store
  const store = useChatStore();
  const currentTopic = store.rooms[open?.topicId as string];

  const renameTopicMutation = useMutation({
    mutationFn: (data: { id: string; newName: string }) => {
      return renameTopic(data?.id, data?.newName);
    }
  });

  const handleSubmit = () => {
    if (!open?.topicId) {
      showNotification('Không tìm thấy ID của topic', 'error');
      return;
    }
    form.validateFields().then((values) => {
      console.log(open.topicId);

      renameTopicMutation.mutate(
        { id: String(open.topicId), newName: values?.name },
        {
          onSuccess: () => {
            store.updateRoomPartial(String(open.topicId), { name: values?.name });
            handleClose();
            showNotification('Đổi tên topic thành công', 'success');
          }
        }
      );
    });
  };

  const handleClose = () => {
    form.resetFields();
    setOpen({ isOpen: false });
  };

  useEffect(() => {
    if (currentTopic?.name) {
      form.setFieldValue('name', currentTopic?.name);
    }
  }, [currentTopic?.name, form]);

  return (
    <Modal
      title='Đổi tên topic'
      open={open?.isOpen}
      onOk={handleSubmit}
      onCancel={handleClose}
      okText='Lưu'
      cancelText='Hủy'
    >
      <Form form={form}>
        <Form.Item label='Tên topic' name='name' rules={[{ required: true, message: 'Vui lòng nhập tên nhóm chat' }]}>
          <Input placeholder='Nhập tên...' />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default TopicRenameModal;
